module.exports = __webpack_public_path__ + "8f56b138dede2bdbfe050f471bc17de4.png";